var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("rect",{"x":"0","width":"90","height":"5"})),React.createElement("g",{"key":1},React.createElement("rect",{"x":"0","y":"28.5","width":"90","height":"5"})),React.createElement("g",{"key":2},React.createElement("rect",{"x":"34","y":"57","width":"56","height":"5"}))]);
}

Hamburger.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 90 62","style":{"enableBackground":"new 0 0 90 62"},"xmlSpace":"preserve"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
